<template>
    <div>
        <!-- step 1 -->
        <SignupProcessVerificationLinkSentDialog />

        <!-- step 2 -->
        <SignupProcessVerifyingLinkDialog />

        <!-- step 3 -->
        <SignupProcessAllDoneDialog />
    </div>
</template>



<script setup lang="ts">

import SignupProcessVerifyingLinkDialog from "@/components/Auth/Signup/SignupSteps/Dialogs/Signup-Process-Verifying-Link.vue";
import SignupProcessAllDoneDialog from "@/components/Auth/Signup/SignupSteps/Dialogs/Signup-Process-All-Done-Dialog.vue";
import SignupProcessVerificationLinkSentDialog from "@/components/Auth/Signup/SignupSteps/Dialogs/Signup-Process-Verification-Link-Sent.vue";

</script>